import React from 'react';

const Pelatihan = () => {
  return (
    <h1>Pelatihan</h1>
  );
};

export default Pelatihan;





